<div class="container mobile-container container-space">
  <div class="box-info">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div class="Title-account d-flex flex-column align-items-start justify-content-start">
        <span>{{ 'Favorites' | translate }}</span>
        <img class="mt-2 d-lg-block d-none"
             src="/icons/line-categories.svg">
      </div>
      <div class="btn-back d-lg-none d-block">
        <span (click)="openBackClicked()">
         {{ 'Back' | translate }}
          <img src="/icons/forward-outline.svg">
        </span>
      </div>
    </div>
    @if (count === 0) {
      <div class="head-success d-flex justify-content-center">
        <img src="/icons/empty-list.svg">
      </div>
      <div class="col-12 mt-5 px-4">
        <app-frontend-button
          [title]="'FavoriteNotFound'"></app-frontend-button>
      </div>
    } @else {
      @for (entityAction of entityActions; track $index) {
        <app-service (addToBasketClicked)="onServiceClicked($event)"
                     [orders]="orders"
                     [service]="entityAction.Service"></app-service>
      }
    }
  </div>
</div>
